import { Project } from "@/types/projects.types";
import * as Yup from "yup";

export const projectMembersValidationSchema = Yup.object<Project>().shape({});

export const projectMemberValidationSchema = Yup.object().shape({
  firstName: Yup.string().required("Le prénom est requis"),
  lastName: Yup.string().required("Le nom est requis"),
});
